export default __webpack_public_path__ + "static/media/chart-empty.acdd4dee.png";